import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module
export default class TwoFactorAuth extends VuexModule {
  protected code: string | null = null;
  protected code_required = false;
  protected error: string | null = null;
  protected submitting = false;
  protected canceled = false;

  get is_tfa_required() {
    return this.code_required;
  }

  get tfa_code() {
    return this.code;
  }

  get get_tfa_error() {
    return this.error;
  }

  get is_tfa_submitting() {
    return this.submitting;
  }

  get is_tfa_canceled() {
    return this.canceled;
  }

  @Mutation
  [Mutations.COMMON_AUTH_TFA_CODE_SET_SUBMITTING](submitting: boolean) {
    this.submitting = submitting;
  }

  @Mutation
  [Mutations.COMMON_AUTH_TFA_CODE_SET_ERROR](error: string | null) {
    this.error = error;
  }

  @Mutation
  [Mutations.COMMON_AUTH_TFA_CODE_SET](auth_code: string | null) {
    this.error = null;
    this.code = auth_code;
  }

  @Mutation
  [Mutations.COMMON_AUTH_TFA_CODE_CHANGE_STATE](is_code_required: boolean) {
    this.code_required = is_code_required;
  }

  @Mutation
  [Mutations.COMMON_AUTH_TFA_CODE_CHANGE_CANCELED](canceled: boolean) {
    this.canceled = canceled;
  }
}
